import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon_paypal.png'
import _imports_1 from '@/assets/image/vipImg/qr_code.png'
import _imports_2 from '@/assets/image/vipImg/qr_code_ko.png'
import _imports_3 from '@/assets/image/vipImg/qr_code_en.png'


const _withScopeId = n => (_pushScopeId("data-v-e7d70898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-way" }
const _hoisted_2 = {
  key: 0,
  class: "pay-way-tab"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("PayPal ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "pay-way-tab"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = {
  key: 2,
  class: "pay-way-tab"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = { class: "pay-way-content" }
const _hoisted_12 = { class: "pay-way-recharge" }
const _hoisted_13 = {
  key: 0,
  class: "recharge-tips"
}
const _hoisted_14 = { class: "pay-way-recharge" }
const _hoisted_15 = { class: "pay-way-recharge-left" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "pay-way-recharge-right" }
const _hoisted_18 = { class: "pay-way-recharge-price" }
const _hoisted_19 = { class: "jp-price" }
const _hoisted_20 = {
  key: 0,
  class: "cn-price"
}
const _hoisted_21 = {
  key: 1,
  class: "us-price"
}
const _hoisted_22 = {
  key: 0,
  style: {"margin-bottom":"10px","color":"#232323"}
}
const _hoisted_23 = { class: "pay-way-tip" }
const _hoisted_24 = { class: "new-member-tips rel" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "abs",
  src: "https://static-s.theckb.com/BusinessMarket/member/new_member_prompt_box@2x.png",
  alt: ""
}, null, -1))
const _hoisted_26 = {
  key: 2,
  class: "pay-way-tip"
}
const _hoisted_27 = { class: "pay-way-btn" }
const _hoisted_28 = {
  key: 0,
  class: "pay-way-recharge",
  style: {"padding":"0","height":"50px"}
}
const _hoisted_29 = { class: "pay-way-rule" }
const _hoisted_30 = { class: "super-vip-code-left" }
const _hoisted_31 = { class: "super-vip-code-text" }
const _hoisted_32 = { class: "super-vip-code-tip" }
const _hoisted_33 = { class: "super-vip-code-right" }
const _hoisted_34 = { class: "super-vip-code-right-code" }
const _hoisted_35 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_36 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_37 = {
  key: 2,
  src: _imports_3,
  alt: ""
}

import { t } from '@/plugins/i18n'
import { ref, computed, nextTick, watch, onMounted } from 'vue'
import { floatingRate, getCurrentMonetaryUnit, formatCountryMoney, formatMoneyDirection } from '@/util/useYan'
import { rechargeMembership, automaticToggle } from '@/apis/usercenter'
import { getMembershipRechargeExchangeRateKrw2Usd } from '@/apis/pay'
import { getCustomerWalletList } from '@/apis/fund'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import CreditCardPay from '@/views/fund/FundList/CreditCardPay.vue'
import PaypalBtn from './PaypalBtn.vue'
import { useSite2Station, isJA, isKO, isEN } from '@/store'
import { getEffectTermByType } from '@/apis/login'
import { Term, Site } from '@/common/const'
import TermModal from '@/components/termModal/index.vue'
import { formatMoney } from '@/plugins/utils'
import { getWallet } from '@/apis/user'


export default /*#__PURE__*/_defineComponent({
  props: {
  templateLevel: {
    type: Number,
    default: 1
  },
  checkValue: {
    type: Number,
    default: 0
  },
  vipInfo: {
    type: Object,
    default: () => {
      return {}
    }
  },
  activeVip: {
    type: Object,
    default: () => {
      return {}
    }
  },
  isJapan: {
    type: Boolean,
    default: false
  },
  isKorea: {
    type: Boolean,
    default: false
  },
  isEnglish: {
    type: Boolean,
    default: false
  }
},
  emits: ['success', 'error'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()
const stationCode = useSite2Station()



/** 获取用户可用余额 */
const rest = ref('0')
if (store.getters.curShop) {
  getWallet({ customerShopId: store.getters.curShop }).then((res) => {
    if (res.success) {
      rest.value = formatMoney(res.data.availableAmount)

    }
  })
}
const mainWallet = ref(0)
onMounted(() => {

  getCustomerWalletList({
    stationCode: useSite2Station(),
    currencyCode: 'CNY'
  }).then((res: any) => {

    const { data } = res
    mainWallet.value = data.find?.((e: any) => e.accountType === 1)?.availableAmount ?? 0
  })
})
const membershipParams = computed(() => {
  return {
    membershipTemplate: {
      membershipTemplateId: props.vipInfo.membershipTemplateId
    },
    membershipTemplatePrice: props.activeVip,
    price: props.vipInfo.discountActualPrice,
    shopId: store.getters.curShop,
    systemSource: store.getters.plat === 'd2c' ? 1 : 2,
    orderType:
      props.checkValue === 2 ||
        props.vipInfo.templateLevel < userInfo.value.membership.templateLevel
        ? 1
        : 0,
    membershipTrialActivityId: props.activeVip.trialFlag
      ? props.activeVip.membershipTrialActivityId
      : undefined,
    membershipTrialActivityComboId: props.activeVip.trialFlag
      ? props.activeVip.membershipTrialActivityComboId
      : undefined
  }
})

console.log(membershipParams, 'membershipParams')
// 解决 0 元付不支持余额问题
watch(() => props.activeVip?.trialDiscount, (val) => {
  console.log(val, 'val')

  if (val === -2 && payWay.value === 3) {
    payWay.value = 1
  }
})

// 2023-7-13 韩国仅支持余额支付。其他默认支付为信用卡支付
// 韩国站也支持信用卡了
const getChoosePayType = () => {
  if (props.isKorea) {
    return 3
  }
  return 1
}
// 支付方式：1-信用卡 2-paypal 3-余额支付.当前默认支付为1.后续可能要根据站点来改
const payWay = ref(1)
const userInfo = computed(() => {
  return store.getters.user
})
const creditCardPayRef = ref()
const currentMonetaryUnit = getCurrentMonetaryUnit()
const loading = ref(false)
const term = ref()
const termModal = ref()
// 余额支付会员
const payRecharge = () => {
  console.log('余额支付会员')
  if (loading.value) return
  loading.value = true

  if (payWay.value === 1) {
    // 信用卡支付
    creditCardPayRef.value.submit(() => {
      loading.value = false
    })
    return
  }
  getCustomerWalletList({ stationCode }).then((res: any) => {
    let availableAmount = 0
    res.data.forEach((item: any) => {
      if (item.accountType === 1) {
        availableAmount = item.availableAmount
      }
    })
    if (
      availableAmount < props.vipInfo.discountActualPrice &&
      !store.getters.curShop
    ) {
      // 余额不足并且没有店铺
      ElMessage.warning(t('余额不足，请先绑定店铺后充值，再重试'))
      loading.value = false
      return
    }
    if (availableAmount < props.vipInfo.discountActualPrice / floatingRate.value) {
      emit('error')
      return
    }
    rechargeMembership({
      membershipTemplate: {
        membershipTemplateId: props.vipInfo.membershipTemplateId
      },
      membershipTemplatePrice: props.activeVip,
      price: props.vipInfo.discountActualPrice,
      shopId: store.getters.curShop,
      systemSource: store.getters.plat === 'd2c' ? 1 : 2,
      orderType:
        props.checkValue === 2 ||
          props.vipInfo.templateLevel < userInfo.value.membership.templateLevel
          ? 1
          : 0,
      membershipTrialActivityId: props.activeVip.trialFlag
        ? props.activeVip.membershipTrialActivityId
        : undefined,
      membershipTrialActivityComboId: props.activeVip.trialFlag
        ? props.activeVip.membershipTrialActivityComboId
        : undefined
    })
      .then((res: any) => {
        if (res.success) {
          loading.value = false
          if (
            !(
              props.checkValue === 2 ||
              props.vipInfo.templateLevel <
              userInfo.value.membership.templateLevel
            )
          ) {
            automaticToggle({
              automaticRenewalStatus: 1,
              automaticRenewalStytle: 1
            })
          }
          emit('success')
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}

const catTerm = async () => {
  try {
    const termDataList = await getEffectTermByType({
      stationCode: stationCode,
      type: Term.utilize
    })
    term.value = termDataList.data[0]
    nextTick(() => {
      termModal.value.open()
    })
  } catch { }
}

const getFloatingRate = (floatingRate: number) => {
  if (!store.getters.isLogin) {
    return Math.round(floatingRate * 100) / 100
  }
  if (!isEN()) {
    return Math.round(floatingRate * 100) / 100
  } else {
    return Math.round((1 / floatingRate) * 100) / 100
  }
}

const exchangeRateKrw2Usd = ref(0)
getMembershipRechargeExchangeRateKrw2Usd().then((res: any) => {
  console.log(res)
  exchangeRateKrw2Usd.value = res.data
})
const usPrice = computed(() => {
  const price = formatMoney(Math.ceil(((props.activeVip.trialFlag ? props.activeVip.trialPrice : props.activeVip.discountActualPrice) / exchangeRateKrw2Usd.value) * 100) / 100)
  return Number(price) > 0.01 ? Number(price) : '0.01'
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass([{ active: payWay.value === 1 }, 'pay-way-tab-item']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (payWay.value = 1))
          }, [
            _hoisted_3,
            _createTextVNode(_toDisplayString(_unref(t)('paypal信用卡')), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ active: payWay.value === 2 }, 'pay-way-tab-item']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (payWay.value = 2))
          }, _hoisted_6, 2),
          (_unref(membershipParams)?.membershipTemplatePrice?.trialDiscount !== -2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ active: payWay.value === 3 }, 'pay-way-tab-item']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (payWay.value = 3))
              }, _toDisplayString(_unref(t)('余额支付')), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isKO)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass([{ active: payWay.value === 1 }, 'pay-way-tab-item']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (payWay.value = 1))
          }, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_unref(t)('paypal信用卡')), 1)
          ], 2),
          (_unref(membershipParams)?.membershipTemplatePrice?.trialDiscount !== -2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ active: payWay.value === 3 }, 'pay-way-tab-item']),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (payWay.value = 3))
              }, _toDisplayString(_unref(t)('余额支付')), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isEN)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass([{ active: payWay.value === 1 }, 'pay-way-tab-item']),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (payWay.value = 1))
          }, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_unref(t)('paypal信用卡')), 1)
          ], 2),
          (_unref(membershipParams)?.membershipTemplatePrice?.trialDiscount !== -2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ active: payWay.value === 3 }, 'pay-way-tab-item']),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (payWay.value = 3))
              }, _toDisplayString(_unref(t)('余额支付')), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(CreditCardPay, {
          type: "vip",
          onSuccess: _cache[7] || (_cache[7] = ($event: any) => (emit('success'))),
          ref: (_value, _refs) => {
            _refs['creditCardPayRef'] = _value
            creditCardPayRef.value = _value
          },
          membershipParams: _unref(membershipParams)
        }, null, 8, ["membershipParams"])
      ], 512), [
        [_vShow, payWay.value === 1]
      ]),
      (payWay.value !== 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('Paypal入金后，如果返金情况，手续费扣除不能返还')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createTextVNode(_toDisplayString(_unref(t)('总计')) + " ", 1),
          (__props.activeVip.finalDiscountPrice && __props.activeVip.finalDiscountPrice > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('已优惠').replace('X',
            _unref(formatMoney)(__props.activeVip.finalDiscountPrice, _unref(isJA)()))), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatMoneyDirection)(__props.activeVip.trialFlag ? __props.activeVip.trialPrice :
              __props.activeVip.discountActualPrice, _unref(isJA)())), 1),
            (!_unref(isKO)())
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(" + _toDisplayString(_unref(formatMoney)((Math.round((__props.activeVip.trialFlag ?
              __props.activeVip.trialPrice :
              __props.activeVip.discountActualPrice)
              / (_unref(floatingRate)) * 100) / 100).toFixed(2), _unref(isJA)())) + _toDisplayString(_unref(t)("元")) + ")", 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString(_unref(usPrice)) + "달러)", 1))
          ]),
          (payWay.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('当前余额')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(mainWallet.value) + " " + _toDisplayString(_unref(t)('元')), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.activeVip.trialFlag)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)("次月续费X円/月").replace("X", _unref(formatMoney)(__props.activeVip.discountActualPrice, _unref(isJA)()))), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('※对于新用户专享活动，如果在会员到期前关闭自动续费，则不会产生使用费。只要没有办理关闭自动续费，就会从下个月开始以正常价格续费。')), 1),
                  _hoisted_25
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" ※為替レートは「" + _toDisplayString(_unref(formatMoneyDirection)(getFloatingRate(_unref(floatingRate)), _unref(isJA)())) + "＝1" + _toDisplayString(_unref(t)("元")) + "」で計算させて頂きます ", 1)
                    ], 64))
                  : (_unref(isKO)())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" ※[₩" + _toDisplayString(exchangeRateKrw2Usd.value) + "=1달러]환율에 따라 계산 ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" ※ The exchange rate is calculated at " + _toDisplayString(getFloatingRate(_unref(floatingRate)) + _unref(t)("元")) + "=1USD ", 1)
                      ], 64))
              ])),
          _createElementVNode("div", _hoisted_27, [
            (payWay.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(PaypalBtn, {
                    vipInfo: __props.vipInfo,
                    activeVip: __props.activeVip,
                    onSuccess: _cache[8] || (_cache[8] = ($event: any) => (emit('success', 'paypal'))),
                    orderType: (props.checkValue === 2 || (props.vipInfo.templateLevel < _unref(userInfo).membership.templateLevel)) ? 1 : 0
                  }, null, 8, ["vipInfo", "activeVip", "orderType"])
                ]))
              : _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass('btn btn' + props.templateLevel),
                  onClick: payRecharge
                }, [
                  _createTextVNode(_toDisplayString(_unref(t)('确认协议并立即支付')), 1)
                ], 2)), [
                  [_directive_loading, loading.value]
                ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createTextVNode(_toDisplayString(_unref(t)("请阅读")) + " ", 1),
            _createElementVNode("span", { onClick: catTerm }, "《" + _toDisplayString(_unref(t)("会员服务协议")) + "》", 1)
          ])
        ])
      ])
    ]),
    (props.templateLevel > 2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass('super-vip-code super-vip-code' + props.templateLevel)
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)("高级会员专享服务")), 1),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)(
              "如需开通商务舱或头等舱会员，请先用line扫描右侧二维码联系我们，获取专属咨询服务。"
            )), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                : _createCommentVNode("", true),
              (_unref(isKO)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                : _createCommentVNode("", true),
              (_unref(isEN)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_37))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModal'] = _value
        termModal.value = _value
      },
      title: _unref(t)('利用规约'),
      "file-url": term.value?.fileUrl,
      "disable-btn": true
    }, null, 8, ["title", "file-url"])
  ]))
}
}

})